import { Oscip } from "@/types/contratacao/oscip"; 
import { FiltrosOscip } from '@/types/contratacao/filtros-oscip'
import { Service } from '../mainService'

const oscipService = {
    pesquisarOscip,
    getPerdaOscipId,
    salvarOscip,
    alterarOscip,
    toggleStatus,
    baixarAnexoOscip,
}

async function pesquisarOscip(filtros: FiltrosOscip, page: number) {
    try {
        const parametros = `?page=${page}&pageSize=10${filtros.toQueryString()}`
        const resp = await Service.$http.get(process.env.VUE_APP_CONTRATACOES_API + "/PerdaQualificacao" + parametros)
        return resp
    } catch (e: any) {
        return e.response;
    }
}

async function getPerdaOscipId(idPerdaQualificacao: string) {
    try {
        const resp = await Service.$http.get(process.env.VUE_APP_CONTRATACOES_API + "/PerdaQualificacao/perdaQualificacaoById/" + idPerdaQualificacao)
        const oscip = Object.assign(new Oscip(), resp.data)
        oscip.tratarDadosDaAPI()
        return oscip
    } catch (e: any) {
        return e.response;
    }
}

async function salvarOscip(oscip: Oscip) {
    try {
        const response = await Service.$http.post(process.env.VUE_APP_CONTRATACOES_API + "/PerdaQualificacao", oscip.toFormData(), {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        });
        return response;
    }
    catch (e: any) {
        console.error('capotou no service', e)
        return e.response;
    }
}

async function alterarOscip(idPerdaQualificacao: string, oscip: Oscip) {
    try {
        const response = await Service.$http.patch(process.env.VUE_APP_CONTRATACOES_API + "/PerdaQualificacao/alterarPerdaQualificacao/" + idPerdaQualificacao, 
            oscip.toFormData(), {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        });
        return response;
    }
    catch (e: any) {
        console.error('capotou no service', e)
        return e.response;
    }
}

async function toggleStatus(idPerdaQualificacao) {
    try {
        const response = await Service.$http.patch(process.env.VUE_APP_CONTRATACOES_API + "/PerdaQualificacao/toggleStatusPerdaQualif/" + idPerdaQualificacao);
        return response;
    } catch (e: any) {
        console.error('capotou no service', e)
        return e.response;
    }
}

async function baixarAnexoOscip(id) {
    try {
      const response = await Service.$http.get(
        process.env.VUE_APP_CONTRATACOES_API + "/PerdaQualificacao/download/" + id,
        { responseType: "blob" }
      );
      return response;
    } catch (e: any) {
      return e.response;
    }
}


export default oscipService;
